import { classes } from "lib/actions/util";
import { PropsWithChildren } from "react";
import styled from "styled-components";
import Tab from "components/elements/Tabs/Tab";

const SidePanelTabBar = (
  p: PropsWithChildren<{
    className?: string;
  }>,
) => (
  <div
    className={classes(
      "flex space-x-6 border-b border-gray-300 text-gray-500",
      p.className,
    )}
  >
    {p.children}
  </div>
);

export default styled(SidePanelTabBar)`
  ${Tab} {
    padding: 0.125rem;
    padding-bottom: 0.5rem;
    margin-bottom: -1px;
    border-bottom-width: 1px;
    border-color: transparent;
    cursor: pointer;
  }
  ${Tab}.tab-active {
    color: rgb(55, 65, 81);
    border-color: black;
  }
  ${Tab}.tab-disabled {
    cursor: default;
    color: rgb(156, 163, 175);
  }
`;
